import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, urls } from '../../../../environments/environment';
import { ICobrancasPixResponse } from '../../interfaces/cobranca-pix.interface';

@Injectable()
export class PixService {

  constructor(private http: HttpClient) { }

  obterTransacaoPix(transacaoPixId) {
    return this.http.get(`${urls.apiBase}/CobrancaPix/ObterPorId?cobrancaPixId=${transacaoPixId}`);
  }

  ObterComAtualizacaoRecebimentoPorId(transacaoPixId) {
    return this.http.get(`${urls.apiBase}/CobrancaPix/ObterComAtualizacaoRecebimentoPorId?cobrancaPixId=${transacaoPixId}`);
  }

  obterTransacoesPorPeriodo(contaId: string, dataInicio: string, dataFim: string): Observable<ICobrancasPixResponse> {
    return this.http.get<ICobrancasPixResponse>(
      `${urls.apiBase}/CobrancaPix/ObterTransacoesPorPeriodo?contaId=${contaId}&dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
  }

}
